var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-login" }, [
    _c("div", { staticClass: "login-card" }, [
      _vm._m(0),
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v("管理密码")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.password,
              expression: "password",
            },
          ],
          ref: "pwd",
          attrs: { type: "password", placeholder: "请输入管理密码" },
          domProps: { value: _vm.password },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.password = $event.target.value
            },
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.doLogin.apply(null, arguments)
            },
          },
        }),
      ]),
      _vm.tip
        ? _c("div", { staticClass: "tip" }, [_vm._v(_vm._s(_vm.tip))])
        : _vm._e(),
      _c(
        "button",
        {
          staticClass: "btn-login",
          attrs: { disabled: _vm.loading },
          on: { click: _vm.doLogin },
        },
        [_vm._v(" " + _vm._s(_vm.loading ? "正在登录…" : "登 录") + " ")]
      ),
      _vm._m(1),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "brand" }, [
      _c("div", { staticClass: "brand-mark" }, [_vm._v("信")]),
      _c("div", { staticClass: "brand-text" }, [
        _c("h1", [_vm._v("信 箱 后 台")]),
        _c("p", [_vm._v("EduAim · 页面发布与维护")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hint" }, [
      _vm._v(" 密码在服务端 "),
      _c("code", [_vm._v("appsettings.json")]),
      _vm._v(" 的 "),
      _c("code", [_vm._v("Admin:Password")]),
      _vm._v(" 中配置（默认 admin123456） "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }